import React from 'react';
import { Button } from 'react-bootstrap';
import AuthorizedAction from '../AuthorizedAction.js';
import { PlusButtonIcon } from '../icons/PlusButtonIcon.jsx';
import SubHeader from '../SubHeader.jsx';
import ChangeInsightsActionDropdown from './ChangeInsightsActionDropdown/ChangeInsightsActionDropdown.jsx';
import ChangeInsightsOverview from './ChangeInsightsOverview.jsx';

const ChangeInsightsHeader = (props) => {
  const {
    initiative,
    initiativeId,
    initiativeType,
    permissions,
    survey,
    surveyResponses,
    changeInsightSettings,
    loading,
    error,
    handleDeleteSurvey,
    handleConfirmSendSurvey,
    handleClickSendSurvey,
    handleClickSendFeedbackForm,
    handleShowAddFeedbackForm,
    handleUpdateEmailSetting,
    handleClickCopyLink,
  } = props;
  return (
    <React.Fragment>
      <SubHeader medium>
        <div className="flex flex-justify">
          <h2 className="horizontal-label">ChangeInsights Studio</h2>
          {initiative.project.manageProjectEntities &&
            (initiative.surveyId && changeInsightSettings ? (
              <ChangeInsightsActionDropdown
                loading={loading}
                survey={changeInsightSettings}
                surveyResponses={surveyResponses}
                initiative={initiative}
                initiativeId={initiativeId}
                initiativeType={initiativeType}
                isArchivedProject={initiative.project.archived}
                changeInsightSettings={changeInsightSettings}
                permissions={permissions}
                errors={error}
                handleDeleteSurvey={handleDeleteSurvey}
                handSendSurvey={handleConfirmSendSurvey}
                handleClickSendSurvey={handleClickSendSurvey}
                handleClickSendFeedbackForm={handleClickSendFeedbackForm}
                handleUpdateEmailSetting={handleUpdateEmailSetting}
                handleClickCopyLink={handleClickCopyLink}
              />
            ) : (
              <AuthorizedAction
                action="update"
                subject={`${initiativeType}Initiative`}
              >
                <Button onClick={handleShowAddFeedbackForm} bsStyle="success">
                  <PlusButtonIcon />
                  Add Feedback Form
                </Button>
              </AuthorizedAction>
            ))}
        </div>
      </SubHeader>

      <ChangeInsightsOverview
        initiative={initiative}
        survey={survey}
        surveyResponses={surveyResponses}
      />
    </React.Fragment>
  );
};

export default ChangeInsightsHeader;
